module.exports = __webpack_public_path__ + "static/media/image-card-11.d6c582d0.png";